import { useEffect } from 'react'
import { useAppStore } from '@/tools/exmarked/stores/appStore'

export function useKeyboard() {
  const view             = useAppStore((s) => s.view)
  const fileTree         = useAppStore((s) => s.fileTree)
  const selectedFilePath = useAppStore((s) => s.selectedFilePath)
  const backToVault      = useAppStore((s) => s.backToVault)
  const backToWorkspace  = useAppStore((s) => s.backToWorkspace)
  const selectFile       = useAppStore((s) => s.selectFile)

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement
      const isInput = (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      )

      // Escape: navigate back one level
      if (e.key === 'Escape' && !isInput) {
        if (view === 'viewer') backToWorkspace()
        else if (view === 'workspace') backToVault()
        return
      }

      // /: focus the sidebar search input
      if (e.key === '/' && !isInput && view !== 'vault') {
        e.preventDefault()
        document.querySelector<HTMLInputElement>('[data-sidebar-search]')?.focus()
        return
      }

      // j / k: navigate to next / previous document (viewer only)
      if ((e.key === 'j' || e.key === 'k') && !isInput && !e.metaKey && !e.ctrlKey) {
        if (view !== 'viewer' || fileTree.length === 0 || !selectedFilePath) return
        const idx = fileTree.findIndex((f) => f.path === selectedFilePath)
        if (idx === -1) return
        const next = e.key === 'j' ? idx + 1 : idx - 1
        if (next >= 0 && next < fileTree.length) {
          const f = fileTree[next]
          selectFile(f.path, f.id)
        }
      }
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [view, fileTree, selectedFilePath, backToVault, backToWorkspace, selectFile])
}
